import React from 'react';
import Steppers from './steppers';

import CardContent from '@material-ui/core/CardContent';

const Estimation =(props)=> (
  <CardContent>
   <Steppers {...props}/>
  </CardContent>
);
export default Estimation